<template>
    <div class="payment">
        <CartNotification :messages="messages"/>
        <div class="payment__inner">
            <div class="header header__offset">                
                <span class="header__role" @click="exit">{{userName}}</span>
            </div>

            <h1 class="order-page__heading" id="top">Оплата</h1>

            <div class="payment__users payment-users">
                <div class="payment-users__headings">
                    <p class="payment-users__heading">Имя</p>
                    <p class="payment-users__heading">К оплате</p>
                    <p class="payment-users__heading">Долг</p>
                    <p class="payment-users__heading">Плат. счет</p>
                </div>

                <div class="payment-users__users">
                    <User
                        class="payment-users__user"
                        v-for="user in employees"
                        @showNotification ="showNotification"
                        :key="user.id"
                        :user_data="user"/> 
                </div>                
            </div>
        </div>

        <div class="navigation order-page__navigation">
            <router-link to="/news" 
                class="navigation__link navigation__link_news">Новости</router-link>
            <a 
                href="/" 
                class="navigation__link navigation__link_now">Текущие</a>
            <router-link to="/archive" 
                class="navigation__link navigation__link_archive">Архив</router-link>

            <router-link to="/payment" 
                class="navigation__link navigation__link_payment active">Оплата</router-link>
        </div>

    </div>
</template>

<script>
import {mapActions ,mapGetters} from 'vuex'
import axios from 'axios'
import User from '@/components/User'
import CartNotification from '@/components/CartNotification'

export default {
    data(){
        return{
            role: '',
            userName: '',
            employees: [],
            messages: [],
        }
    },
    methods: {
        ...mapActions([
            'GET_EMPLOYEES'
        ]),
        getRole(){
            this.role = localStorage.getItem('role')
            this.userName = localStorage.getItem('name')
        },
        exit(){
            let isExit = confirm("Выйти?");
            if(isExit){
                document.cookie = `token = ''; max-age=-1`
                this.$router.push('/login')
            } 
        },
        getEmployees(){
            let cookie = document.cookie.match(/token=(.+?)(;|$)/);
            this.role = localStorage.getItem('role')
            
            if (this.role != "ADMIN") { 
                axios.get('https://lk-berry1.ru:3000/api/user/getMyData',{headers: {Authorization: `Bearer ${cookie[1]}`}}).then((res)=>{
                    console.log(res.data);
                    
                this.employees.push(res.data) 
            })
            }else{
                    axios.get('https://lk-berry1.ru:3000/api/user/employees',{headers: {Authorization: `Bearer ${cookie[1]}`}}).then((res)=>{
                    this.employees = res.data
                })
            }                    
        },
        showNotification(){
            let timeStamp = Date.now().toLocaleString()
            this.messages.unshift(
                {name: "Обновлено!", id: timeStamp}
            )
        }
    },
    components: {
        User,
        CartNotification
    },
    mounted(){
        this.getEmployees()
        this.getRole()
    }
}
</script>

<style scoped>
    .payment__inner{
        padding: 10px 15px;
        padding-bottom: 80px;
        max-width: 600px;
        margin: 0 auto;
        border: 2px solid #000;
        border-radius: 2px;
        margin-top: 15px;
        background-color: #eee;
    }
    .header__offset{
        display: flex;
        justify-content: flex-end;
        padding-bottom: 10px;
        border-bottom: 1px solid #000;
    }
    .header__role{
        position: relative;
        padding: 15px 45px 15px 0;
        margin-left: auto;
    }
    .header__role::after{
        position: absolute;
        content: "";
        height: 35px;
        width: 35px;
        right: 0;
        top: 50%;
        margin-top: -20px;
        background: url(../images/exit.png) no-repeat;
        background-size: contain;
    }
    .payment-users__headings{
        display: grid;
        width: 100%;
        grid-template-columns: repeat(4, 1fr);
        border: 1px solid #000;        
    }
    .payment-users__heading{
        text-align: center;
        padding-top: 10px;
        padding-bottom: 10px;
        border-right: 1px solid #000;
        font-weight: 500;
    }
    .payment-users__heading:last-child{
        border-right: none;
    }
    .order-page__navigation{
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        display: flex;
        background-color: #eee;
        border-top: 1px solid #d8d8d8;
    }
    .payment-users__user{
        margin-top: -1px;
    }
    .navigation__link{
        flex-basis: 33.333%;
        position: relative;
        padding: 50px 25px 10px;
        font-size: 12px;
        text-decoration: none;
        color: #000;
        border-right: 1px solid #d8d8d8;
        text-align: center;
    }
    .navigation__link::before{
        position: absolute;
        content: "";
        width: 40px;
        height: 40px;
        top: 5px;
        left: 50%;
        margin-left: -20px;
    }
    .navigation__link:last-child{
        border-right: none;
    }
    .navigation__link_news::before{
        background: url(../images/news-ico.svg) no-repeat;
        background-size: contain;
        background-position: center;
    }
    .navigation__link_now::before{
        background: url(../images/now2.png) no-repeat;
        background-size: contain;
        background-position: center;
    }
    .navigation__link_add::before{
        background: url(../images/add4.png) no-repeat;
        background-size: contain;
        background-position: center;
    }
    .navigation__link_archive::before{
        background: url(../images/archive.png) no-repeat;
        background-size: contain;
        background-position: center;
    }
    .navigation__link_payment::before{
        background: url(../images/payment.svg) no-repeat;
        background-size: contain;
        background-position: center;
    }
    .active{
        background-color: #d8d8d8;
        pointer-events: none;
    }
    .order-page__heading{
        text-align: center;
        margin-top: 15px;
        margin-bottom: 15px;
    }
    @media (max-width: 600px){
        .header__role{
            font-size: 14px;
        }
        .order-page__heading{
            font-size: 26px;
        }
        .payment-users__headings{
            display: none;
        }
        .payment-users__user{
            margin-bottom: 25px;
        }
    }
</style>